import { render, staticRenderFns } from "./officeTypeForm.vue?vue&type=template&id=ec525d4e&%23default=true&"
import script from "./officeTypeForm.vue?vue&type=script&lang=js&"
export * from "./officeTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports